import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Role {
  id: number;
  name: string;
  description: string;
}

interface RoleState {
  availableRoles: Role[];
}

const initialState: RoleState = {
  availableRoles: [],
};

const roleSlice = createSlice({
  name: 'roles',
  initialState,
  reducers: {
    setAvailableRoles(state, action: PayloadAction<Role[]>) {
      state.availableRoles = action.payload;
    },
    clearAvailableRoles(state) {
      state.availableRoles = [];
    },
  },
});

export const { setAvailableRoles, clearAvailableRoles } = roleSlice.actions;
export const roleReducer = roleSlice.reducer;
